import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const Container = styled(BaseContainer)`
  margin-top: ${props => (props.theme.isMobile ? '32px' : '16px')};
  margin-bottom: ${props => (props.theme.isMobile ? '32px' : '16px')};
`;

const Image = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    max-width: 560px;
    width: 44vw;
  `)};
`;

const SectionNameExt = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
`;

const BaseDescExt = styled(BaseDesc)`
  a {
    color: #1E58CF;
    text-decoration: underline;
  }
`;

export default function ProfessionalInvestors() {
  const { professionalInvestorsImage, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#professional_investors', 0);

  return (
    <Container id="professional_investors">
      <Plx className="left-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionNameExt>Professional Audience</SectionNameExt>
        <BaseTitle>Connect with professional investors</BaseTitle>
        <BaseDescExt>
          Our brands have a significant representation of  financial professionals,
          including Financial Advisers, Family Offices, Brokers, Fund Managers & Analysts,
          Institutional Investors, Research Consultants, as well as global and local
          Professional Services firms.
        </BaseDescExt>
      </Plx>
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <Image src={professionalInvestorsImage} />
      </Plx>
    </Container>
  );
}
